export default __webpack_public_path__ + "static/media/disabled-close.fd0834b4.svg";